export interface IEnvironment {
	environment: EEnvironment
	operationGateway: string
	gateway: string
	signinRedirectUrl: string
	signoutRedirectUrl: string
}

export enum EEnvironment {
	prod = 'prod',
	test = 'test',
	dev = 'dev',
	local = 'local',
	unknown = 'unknown',
}
